var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"layout"},[_c('Main'),_c('Second'),_c('Third'),_c('Slider'),_c('Contacts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }